import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'


const StatusForecastDataFilterOptions = [
	{value: 'arb_only', label: 'nur Arbeitszeitrelevante (Standard)'},
	{value: 'abw_only', label: 'nur Abwesende'},
	{value: 'all', label: 'Alle anzeigen'},
]

export const StatusForecastUserConfigDict = {
	enabled: {
		label: 'Vorschau',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.statusForecastDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.statusForecastVis, propDefaultTrue),
		userConfig: {
			dataFilter: {
				label: 'Angezeigte Daten',
				type: 'select',
				defaultValue: StatusForecastDataFilterOptions[0].value,
				visibleSelector: () => true,
				transformValue: (value: string) => StatusForecastDataFilterOptions.find(x => x.value === value)?.value,
				transformOnChange: ({value}: { value: string }) => value,
				slctProps: {
					options: StatusForecastDataFilterOptions,
					hideClearButton: true,
				},
			},
		},
	},
} as const